// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rko1","label":"styles_label__2ADXv"};